<template>
  <el-dialog
    :title="selectedItemId === null ? '新增群組' : '編輯群組'"
    :visible.sync="innerVisible"
  >
    <el-form :model="form" ref="form" :rules="rules">
      <el-form-item label="部門" :label-width="formLabelWidth">
        <el-input :value="deptName" readonly autocomplete="off"></el-input>
      </el-form-item>

      <el-form-item label="群組名稱" :label-width="formLabelWidth" prop="name">
        <el-input v-model="form.name" autocomplete="off"></el-input>
      </el-form-item>

      <el-form-item label="備註" :label-width="formLabelWidth">
        <el-input type="textarea" v-model="form.memo"></el-input>
      </el-form-item>

      <el-form-item label="顏色" :label-width="formLabelWidth" prop="color">
        <div style="width:480px;marginBottom:-20px">
        <el-radio-group v-model="form.color">
          <el-radio
              v-for="itemColor in extTagColorList"
              :key="itemColor.name"
              :label="itemColor.name"
          >
              <span :style="{ color: itemColor.textColor }">
                {{ itemColor.txtLabel }}
              </span>
          </el-radio
          >
        </el-radio-group>
        </div>
      </el-form-item>
    </el-form>
    <template #footer class="dialog-footer">
      <el-button @click="innerVisible = false">取 消</el-button>
      <el-button type="primary" @click="submit">確 定</el-button>
    </template>
  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import tagColorsMixin from "@/components/mixin/tagColors.js";
export default {
  mixins: [tagColorsMixin],
  model: {
    prop: "visible",
    event: "toggleVisible",
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    deptId: {
      type: Number,
      default: null,
    },
    deptName: {
      type: String,
      default: null,
    },
    selectedItemId: {
      type: Number,
      default: null,
    },
  },
  computed: {
    ...mapGetters({
      myownOrg: "auth/orgName",
    }),
    innerVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("toggleVisible", val);
      },
    },
  },
  data() {
    return {
      rules: {
        name: [{ required: true, message: "請輸入部門名稱", trigger: "blur" }],
        adminIds: [
          { required: true, message: "請選擇管理員", trigger: "blur" },
          //{ validator: validatePass, trigger: 'blur' },
        ],
        color: [{ required: true, message: "請輸入顏色", trigger: "blur" }],
      },
      formLabelWidth: "100px",
      form: {
        name: "",
        memo: "",
        color: "primary",
      },
    };
  },
  created() {
    if (this.innerVisible) {
      if (this.selectedItemId !== null) {
        const data = this.$store.getters["group/getGroupById"](
          this.selectedItemId
        );
        this.form.id = data.id;
        this.form.name = data.name;
        this.form.memo = data.memo;
        this.form.color = data.color;
      }
      this.form.deptId = this.deptId;
    }
  },
  methods: {
    submit() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          if (this.selectedItemId !== null) {
            this.submitUpdate();
          } else {
            this.submitAdd();
          }
        } else {
          return false;
        }
      });
    },
    submitAdd() {
      this.$store.dispatch("group/add", this.form).then(() => {
        this.innerVisible = false;
        this.$store.dispatch("group/list", null);
      });
    },
    submitUpdate() {
      this.$store.dispatch("group/update", this.form).then(() => {
        this.innerVisible = false;
        this.$store.dispatch("group/list", null);
      });
    },
  },
};
</script>

<style></style>
